export default {
  fbSDKInstance: {},
  googleSDKInstance: {},
  setFbSDKInstance(instance) {
    this.fbSDKInstance = instance;
  },
  setGoogleSDKInstance(instance) {
    this.googleSDKInstance = instance;
  },
};



// WEBPACK FOOTER //
// ./src/consts/sdk-instances.js